import { useMemo } from "react";
import { EServiceGroup, NUMBER_OFFER_MAX } from "@constants";
import { ICart } from "../ICart";
import { selectOfferInCartByServiceGroup } from "@utils/offerUtils";
import { useOffers } from "@hooks/useOffers";
import { useAddOffer } from "@hooks/useAddOffer";
import { getProspectReference } from "@utils/storage";

interface IUseMobileRequiredModalParams {
    cart: ICart;
    setCart(cart: ICart | undefined): void;
}

export const useMobileRequiredModal = (params: IUseMobileRequiredModalParams) => {
    const { cart, setCart } = params;
    const { offerList } = useOffers();
    const { addMobileOffer } = useAddOffer();

    const hasBroadbandInCart = useMemo(() => Boolean(selectOfferInCartByServiceGroup(cart, EServiceGroup.SA_BB)), [
        cart,
    ]);

    const hasMobileInCart = useMemo(() => Boolean(selectOfferInCartByServiceGroup(cart, EServiceGroup.MOBILE)), [cart]);

    const firstMobileOffer = useMemo(() => offerList.find((offer) => offer.serviceGroup === EServiceGroup.MOBILE), [
        offerList,
    ]);

    const showMobileRequiredModal = useMemo(() => {
        if (!cart || !hasBroadbandInCart || hasMobileInCart) {
            return false;
        }

        return cart.nbrAdditionalAllowedMobileSubscriptions === NUMBER_OFFER_MAX;
    }, [cart, hasBroadbandInCart, hasMobileInCart]);

    const handleAddGoMoMobile = () => {
        const prospectReference = getProspectReference();
        if (firstMobileOffer && prospectReference) {
            addMobileOffer(firstMobileOffer.catalogOfferCode, prospectReference).then((cartResult) => {
                if (cartResult) {
                    setCart(cartResult);
                }
            });
        }
    };

    return {
        showMobileRequiredModal,
        handleAddGoMoMobile,
    };
};
